(ns app.front.view.inspections.my-today
  (:require ["@carbon/icons-react/es/forum/24" :default Forum24]
            [app.domain.booking.model :as booking-model]
            [app.domain.group.config.model :as config-model]
            [app.domain.inspection.model :as inspection-model]
            [app.domain.municipality.model :as municipality-model]
            [app.domain.util :as du]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.root :as root]
            [app.front.ui :as ui]
            [app.front.ui.section :as section]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil :refer [for-all]]
            [app.front.view.dispatch.subs :as dispatch-subs]
            [app.front.view.inspections.quick-pass :as inspections-quick-pass]
            [app.front.view.inspections.reassign-inspector :as inspection-reassign]
            [app.front.view.inspections.subs :as inspection-sub]
            [app.front.view.navigation :as nav]
            [clojure.string :as str]
            [core.db.entity.util :as eu]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(defn whole-address [workspace tr lang]
  (let [address       (or (-> workspace :workspace/address)
                          (futil/location-coordinates workspace)
                          (tr [:address/address-missing]))
        muni-province (-> workspace
                          :workspace/municipality
                          (municipality-model/common-name-province tr lang))]
    (str address ", " muni-province)))


(def cancelled? (du/in-state-fn :booking.state/cancelled))


(defn inspection-href [inspection]
  (href/href :view/inspection-visit
             {:inspection-id (:db/id inspection)
              :workspace-id  (-> inspection inspection-model/workspace :workspace/id)}))

(defn has-result? [{:inspection.visit/keys [visit-result result]}]
  (some? (or visit-result result))) ;;TODO remove result when :feature-flag.id/inspection-visit-configuration removed

(defn passed-visit? [visit]
  (or (-> visit :inspection.visit/visit-result inspection-model/passed-or-completed-result?)
      (-> visit :inspection.visit/result (= :inspection.visit.result/passed)))) ;;TODO remove result when :feature-flag.id/inspection-visit-configuration removed

(rf/reg-sub ::bookings
  :<- [::inspection-sub/my-bookings-for-the-selected-day]
  (fn [bookings _]
    (->> bookings
         (filter (complement cancelled?)))))


(rf/reg-event-fx ::go-to-inspection
  (fn [{:keys [db]} [_ inspection]]
    {:route/redirect-to-path {:path   (inspection-href inspection)
                              :router (:core.front.routing/router db)}}))


(rf/reg-sub ::bookings-to-show
  :<- [::show-cancelled?]
  :<- [::inspection-sub/my-bookings-for-the-selected-day]
  (fn [[show-cancelled all-bookings] _]
    (if (boolean show-cancelled)
      all-bookings
      (filter (complement cancelled?) all-bookings))))


(rf/reg-sub ::missed-bookings-to-show
  :<- [::inspection-sub/my-missed-bookings-for-the-selected-day]
  (fn [missed-bookings _]
    (->> missed-bookings
         (filter (complement cancelled?))
         (sort-by :booking/actual-start-time)
         reverse)))


(defn event-start [e] (or (:booking/actual-start-time e) (:external-event/start e)))
(defn event-end [e] (or (:booking/actual-end-time e) (:external-event/end e)))


(rf/reg-sub ::my-scheduled-events
  :<- [::bookings-to-show]
  :<- [::inspection-sub/my-external-events-for-the-selected-day]
  (fn [[bookings external-events] _]
    (->> (concat bookings external-events)
         (sort-by (juxt event-start event-end :ordered/order)))))


(rf/reg-sub ::route
  :<- [::inspection-sub/my-bookings-for-the-selected-day]
  :<- [:tr]
  :<- [:language]
  (fn [[bookings tr lang] _]
    (-> (->> bookings
             ;; only include inspections that have not yet been started in the navigation
             (filter (du/in-state-fn :booking.state/dispatched))
             (keep (fn [b]
                     (let [workspace (booking-model/get-workspace b)]
                       (cond (-> workspace :workspace/structural-address :address/address-source (= :address-source/gis))
                             (whole-address workspace tr lang)

                             (:entity/location workspace)
                             (futil/location-coordinates workspace)

                             (:workspace/address workspace)
                             (whole-address workspace tr lang)))))
             (str/join "/"))
        (str/replace " " "+"))))


(rf/reg-sub ::cancelled-count
  :<- [::inspection-sub/my-bookings-for-the-selected-day]
  (fn [bookings _]
    (->> bookings
         (filter cancelled?)
         count)))


(rf/reg-sub ::no-content?
  :<- [::inspection-sub/today-selected?]
  :<- [::inspection-sub/ongoing-visits]
  :<- [::inspection-sub/my-bookings-for-the-selected-day]
  :<- [::inspection-sub/finished-visits-for-the-selected-day]
  (fn [[today-selected? on-going-visits bookings finished] _]
    (cond-> (concat bookings finished)
      today-selected? (concat on-going-visits)
      true empty?)))


(rf/reg-sub ::inspection-passed?
  :<- [::entities/entities {:entity/type :entity.type/inspection-visit}]
  (fn [visits [_ {inspection-id :db/id}]]
    (let [booking-visits (filter #(= inspection-id (-> % :entity/parent :db/id)) visits)]
      (and (not-empty booking-visits)
           (every? (du/in-state-fn :inspection.visit.state/done) booking-visits)
           (some passed-visit? booking-visits)))))


(rf/reg-event-db ::set-show-cancelled
  (fn [db [_ value]]
    (assoc db ::show-cancelled? value)))


(rf/reg-sub ::show-cancelled? :-> ::show-cancelled?)




(defn open-inspection-button [{:keys [kind inspection]} text]
  (when (inspection-model/workspace inspection)
    (cc/button
      {:size       :small
       :class-name "max-w-full"
       :data-cy    "inspection-btn"
       :on-click   #(.stopPropagation %)
       :href       (inspection-href inspection)
       :kind       kind}
      text)))


(defn phone-link [{:user/keys [mobile-phone]}]
  (cc/link
    {:href (str "tel:" mobile-phone)}
    mobile-phone))


(defn sms-link [tr {:user/keys [mobile-phone]}]
  (when mobile-phone
    (cc/button
      {:href             (str "sms:" mobile-phone)
       :data-cy          "sms-btn"
       :kind             :tertiary
       :size             :small
       :on-click         #(.stopPropagation %)
       :icon             Forum24
       :icon-description (tr [:inspection/sms-title])}
      (tr [:inspection/sms-title]))))


(defn booking-action-col [{:keys [tr creator]}
                          {state      :domain/state
                           inspection :entity/parent
                           :as        booking}]
  (let [cancelled? (= :booking.state/cancelled state)
        fulfilled? (= :booking.state/fulfilled state)
        passed?    (<sub [::inspection-passed? inspection])
        kind       (if fulfilled? :tertiary :primary)]
    (when-not cancelled?
      [:div.flex.flex-col.sm:flex-row.lg:flex-col.space-y-3.sm:space-y-0.lg:space-y-3.sm:space-x-2.lg:space-x-0.items-end
       (if (inspection-model/quick-pass-applicable? inspection)
         [inspections-quick-pass/quick-pass-button (util/mmap tr inspection)]
         [open-inspection-button
          (util/mmap kind inspection)
          (cond
            passed? (tr [:inspection/view-inspection])
            fulfilled? (tr [:inspection/continue-inspection])
            :else (tr [:inspection/inspect]))])
       [sms-link tr creator]
       (cc/button
         {:size     :small
          :kind     :ghost
          :on-click #(do (.stopPropagation %)
                         (>evt [::inspection-reassign/start-reassign [booking]]))}
         (tr [:inspection/reassign]))])))


(defn visit-action-col [text-for-button
                        {:keys [tr]}
                        {inspection :entity/parent}]

  [open-inspection-button
   (util/mmap {:kind :tertiary} inspection)
   ((workspace-model/workspace-tr-fn tr (inspection-model/workspace inspection))
    [text-for-button])])


(defn duration [tz start end]
  (str (date-util/hour-minute-in-tz start tz)
       "-"
       (date-util/hour-minute-in-tz end tz)
       " "
       (date-util/time-zone-name tz {})))


(defn booking-time [{:keys [:booking/actual-start-time :booking/actual-end-time :entity/parent]}]
  (duration (inspection-sub/get-timezone-for-inspection parent)
            actual-start-time
            actual-end-time))


(defn booking-date [{:keys [:booking/actual-start-time :entity/parent]}]
  (date-util/date-in-tz actual-start-time (inspection-sub/get-timezone-for-inspection parent)))


(defn event-time [tr {:external-event/keys [start end] :as event}]
  (if (dispatch-subs/all-day-event? event)
    (tr [:dispatching/all-day])
    (duration (inspection-sub/get-timezone-for-external-event event) start end)))


(defn visit-time [{:keys [:inspection.visit/start-time :entity/parent] :as visit}]
  (let [tz (inspection-sub/get-timezone-for-inspection parent)]
    (if (inspection-sub/visit-starts-today? visit)
      (str (date-util/hour-minute-in-tz start-time tz)
           " "
           (date-util/time-zone-name tz {}))
      (str (date-util/date-in-tz start-time tz)
           " "
           (date-util/time-zone-name tz {})))))


(defn show-cancelled-selector [{:keys [tr]}]
  (let [cancelled-count (<sub [::cancelled-count])]
    (when (> cancelled-count 0)
      [:div.bx--col-xs-12.flex.justify-end.show-cancelled-checkbox
       (cc/checkbox {:id         :show-cancelled
                     :label-text (str (tr [:inspection/show-also-cancelled]) " (" cancelled-count ")")
                     :checked    (boolean (<sub [::show-cancelled?]))
                     :on-change  #(>evt [::set-show-cancelled %])})])))


(def row-classes "mb-2 bg-gray-100 rounded-lg")
(def h2 :h2.mb-2.leading-none.text-xs.text-gray-600.font-normal)
(def inspection-state->colors {:booking.state/cancelled            ["bg-status-neutral-01" "var(--ui-white)"]
                               :booking.state/dispatched           ["bg-status-neutral-02" "var(--ui-night-sky-100)"]
                               :booking.state/to-dispatch          ["bg-status-neutral-02" "var(--ui-night-sky-100)"]
                               :booking.state/fulfilled            ["bg-status-warning" "var(--ui-night-sky-100)"]
                               :inspection.visit.state/in-progress ["bg-status-warning" "var(--ui-night-sky-100)"]
                               :inspection.visit.result/passed     ["bg-status-success" "var(--ui-night-sky-100)"]
                               :inspection.visit.result/not-passed ["bg-status-error" "var(--ui-night-sky-100)"]})
(def missed-colors ["bg-status-attention" "var(--ui-night-sky-100)"])



(defn booking-field [text cancelled? class]
  [:div {:class (futil/cs
                  class
                  "leading-tight"
                  (when cancelled? "line-through"))}
   [:span.cursor-auto
    {:data-cy  "scheduled-inspection-type"
     :on-click #(.stopPropagation %)}
    text]])

(defn notes-field [{:keys [booking key tr-key]}]
  (when-let [notes (-> booking key)]
    (let [tr (<sub [:tr])]
      [:div.mb-4.last:mb-0
       [h2 (tr [(or tr-key key)])]
       [booking-field notes]])))

(def cell :div.mx-4.lg:m-4)

(defn list-section
  "List of either bookings or inspection-visits."
  [{:keys [title tr items get-booking time-col action-col item-count missed?]
    :as   props
    :or   {get-booking identity}}
   additional-controls]
  [section/section
   title
   props
   (str (tr [title]) (when item-count (str " (" item-count ")")))
   additional-controls
   #_{:clj-kondo/ignore [:deprecated-var]}
   [ui-table/responsive-table
    {:tr                 tr
     :row-class-override "items-start"
     :headerless?        true}
    [{:width "70px"}
     {:flex 4}
     {:flex 5}
     {:flex 2}
     {:width "200px"}]
    (for-all [item items]
      (let [tr (workspace-model/workspace-tr-fn tr (booking-model/get-workspace item))]
        (if (contains? #{:entity.type/inspection-visit :entity.type/booking} (:entity/type item))
          (let [booking                 (get-booking item)
                state                   (-> booking :domain/state)
                cancelled?              (= state :booking.state/cancelled)
                simplified-visit-result (when (has-result? item)
                                          (if (passed-visit? item)
                                            :inspection.visit.result/passed
                                            :inspection.visit.result/not-passed))
                inspection              (when (->> item :entity/parent (eu/is-type? :entity.type/inspection))
                                          (:entity/parent item))
                ;; assuming all possible items are great-great grandchildren of workspaces,
                ;; at the moment this is true for both bookings and inspection visits
                ws                      (-> item :entity/parent :entity/parent :entity/parent)
                ws-id                   (:workspace/id ws)
                ws-href                 (href/href :view/workspace {:workspace-id ws-id})
                project                 (workspace-model/project ws)
                project-href            (href/href :view/project {:project-id (:db/id project)})
                ;; entity-db is used because entity/creator is not a reference - entity-api won't work
                creator                 (<sub [::entities/entity (-> booking :entity/creator :db/id)])
                creator-name            (user-model/full-name creator)
                empty-name?             (str/blank? creator-name)
                props                   (assoc props :creator creator)
                [icon-bg icon-fg]       (if missed?
                                          missed-colors
                                          (get inspection-state->colors (or simplified-visit-result
                                                                            (:domain/state item)
                                                                            state)))
                lang                    (<sub [:language])
                code-enforcement?       (-> ws :workspace/permit-type (= :permit-type/CE))]
            {:key  (:db/id item)
             ;; Whole item "card" is a link to the inspection if one exists
             ;; Note the need for .stopPropagation for any clickable elements this introduces
             :opts {:data-cy   "single-scheduled-inspection"
                    :class     (futil/cs row-classes
                                         "border-2 border-solid border-ui-white"
                                         (when inspection
                                           "cursor-pointer hover:border-ui-blue-100"))
                    :tab-index 0
                    :on-key-up #(when (and inspection
                                           (futil/enter-press? %))
                                  (>evt [::go-to-inspection inspection]))
                    :on-click  #(when inspection
                                  (>evt [::go-to-inspection inspection]))}
             :cols [{:opts    {:class     "w-full h-full"
                               :col-class "w-full"}
                     :content [:div.h-full.flex.justify-center.items-center.rounded-t-lg.lg:rounded-tr-none
                               {:class (or icon-bg "bg-brand-pale-blue")}
                               (cc/icon {:icon        i/location
                                         :description ""
                                         :aria-hidden true
                                         :class-name  "my-4"
                                         :fill        (or icon-fg "var(--ui-night-sky-100)")
                                         :height      "32px"
                                         :width       "32px"})]}
                    {:content [cell
                               [h2 (tr [:inspection/address-title])]
                               [booking-field
                                (cc/link {:href ws-href :class-name "leading-tight"}
                                         (whole-address ws tr lang))
                                cancelled?
                                "mb-4"]
                               [h2 (tr [:inspection/inspection-title])]
                               [booking-field
                                (-> item
                                    :entity/parent
                                    (inspection-model/inspection-name lang))
                                cancelled?
                                "mb-4"]
                               (when (not code-enforcement?)
                                 [:<>
                                  [h2 (tr [:inspection/requester-title])]
                                  [booking-field (if-not empty-name? creator-name "-") cancelled? "lg:mb-4"]])]}
                    {:content [cell
                               ;; Phone number and scheduled time
                               [:div.flex.flex-row.space-x-4.mb-6.lg:mb-4
                                (when (and
                                        (not code-enforcement?)
                                        (:user/mobile-phone creator))
                                  [:div.w-1-2
                                   [h2 (tr [:inspection/phone-title])]
                                   [booking-field [phone-link creator] cancelled? "mb-4"]])
                                [:div.w-1-2
                                 [h2 (tr [:inspection/time-title])]
                                 [booking-field [time-col item] cancelled?]]]
                               ;; Project title and category
                               [:div.flex.flex-row.space-x-4
                                (when project
                                  [:div.w-1-2
                                   [h2 (tr [:inspection/project])]
                                   [booking-field
                                    (cc/link {:href project-href :class-name "leading-tight"} (:project/name project))
                                    cancelled?]])
                                (when-let [category (config-model/category-name ws lang)]
                                  [:div.w-1-2
                                   [h2 (tr [:workspace/category])]
                                   [booking-field category]])

                                ;; Notes
                                [notes-field (util/mmap {:key    :booking/notes
                                                         :tr-key :inspection/booking-notes}
                                                        booking)]]
                               [notes-field (util/mmap {:key :booking/dispatch-notes}
                                                       booking)]]}
                    {:opts    {:class "self-center mr-2"}
                     :content [:div.ml-4.mb-4.lg:m-0.flex.lg:justify-end.lg:align-center.lg:h-full
                               [action-col (assoc props :tr tr) item]]}]})
          {:key  (:db/id item)
           :opts {:class row-classes}
           :cols [{:opts    {:class     "self-stretch"
                             :col-class "w-full"}
                   :content [:div.h-full.bg-ui-blue-100.flex.justify-center.items-center.rounded-t-lg.lg:rounded-l-lg.lg:rounded-t-none
                             (cc/icon {:icon        i/calendar
                                       :description ""
                                       :aria-hidden true
                                       :class-name  "my-4"
                                       :fill        "#ffffff"
                                       :height      "18"
                                       :width       "18"})]}
                  {:content [cell
                             [h2 (tr [:inspection/name])]
                             [:div.leading-tight
                              (:external-event/subject item)]]}
                  {:content [cell
                             [h2 (tr [:inspection/location])]
                             (or (:external-event/location item) "-")]}
                  {:content [:div.mx-4.mb-4.lg:mt-4
                             [h2 (tr [:inspection/time])]
                             (event-time tr item)]}
                  {:opts {:class "mr-4"}}]})))]])


(defn missed-list [props]
  (let [items (<sub [::missed-bookings-to-show])]
    (when (seq items)
      [list-section
       (assoc props
              :title :inspection/missed-events
              :item-count (count items)
              :items items
              :time-col booking-date
              :action-col booking-action-col
              :missed? true)])))


(defn bookings-list [props]
  (let [cancelled-count (<sub [::cancelled-count])
        items           (<sub [::my-scheduled-events])]
    (when (or (seq items)
              (> cancelled-count 0))
      [list-section
       (assoc props
              :title :inspection/scheduled-events
              :item-count (count items)
              :items items
              :time-col booking-time
              :action-col booking-action-col)
       [show-cancelled-selector props]])))


(defn ongoing-inspections-list [props]
  (let [visits (<sub [::inspection-sub/ongoing-visits])]
    (when (seq visits)
      [list-section
       (assoc props
              :title :inspection/in-progress
              :items visits
              :item-count (count visits)
              :get-booking :inspection.visit/booking
              :time-col visit-time
              :action-col (partial visit-action-col :inspection/continue-inspection))])))


(defn done-inspections-list [props]
  (let [visits (<sub [::inspection-sub/finished-visits-for-the-selected-day])]
    (when (seq visits)
      [list-section
       (assoc props
              :title :inspection/completed-visits
              :items visits
              :item-count (count visits)
              :get-booking :inspection.visit/booking
              :time-col visit-time
              :action-col (partial visit-action-col :inspection/view-inspection))])))


(defn reassign-modal []
  (let [tr            (<sub [::root/permit-types-tr (<sub [::inspection-reassign/permit-types])])
        assigning-to  (<sub [::inspection-reassign/assigning-to])
        assigning-ids (<sub [::inspection-reassign/assigning-ids])]
    [ui/confirm-modal
     {:tr              tr
      :id              "my-today"
      :class           "small-modal"
      :modal-title     (tr [:inspection/reassign-title])
      :yes-disabled?   (not (<sub [::inspection-reassign/assigning-to]))
      :open?           (boolean (<sub [::inspection-reassign/reassign]))
      :yes-button-text (tr [:inspection/reassign])
      :no-button-text  (tr [:cancel])
      :on-close        #(>evt [::inspection-reassign/assign-done])
      :on-yes-click    #(>evt [::inspection-reassign/do-assign
                               assigning-to
                               assigning-ids])}
     [inspection-reassign/selector tr nil true]]))


(defn calendar-component [tr]
  [:div.flex.flex-col.md:flex-row.items-start.md:items-center.mt-6.lg:mt-0.lg:ml-4.justify-between
   [:div.flex.flex-row.items-center
    (cc/button
      {:on-click         #(>evt [::inspection-sub/select-my-today-date (date-util/today-start-of-day)])
       :kind             :tertiary
       :class-name       "mr-2"
       :icon-description (tr [:inspection/today's-events])
       :disabled         (<sub [::inspection-sub/today-selected?])}
      (tr [:inspection/today's-events]))
    [:a.pr-2
     {:href     "#"
      :on-click #(>evt [::inspection-sub/select-my-today-date (date-util/add-days-to-date (<sub [::inspection-sub/my-today-date]) -1)])}
     (cc/icon {:icon        i/chevron-left
               :description (tr [:dispatching/previous-date])
               :data-cy     "yesterday"
               :fill        "var(--text-dark)"})]
    [ui/date-picker {:callback  #(>evt [::inspection-sub/select-my-today-date %])
                     :value     (or (<sub [::inspection-sub/my-today-date])
                                    (date-util/today-start-of-day))
                     :disabled? false
                     :tr        tr}]
    [:a.px-2
     {:href     "#"
      :on-click #(>evt [::inspection-sub/select-my-today-date (date-util/add-days-to-date (<sub [::inspection-sub/my-today-date]) 1)])}
     (cc/icon {:icon        i/chevron-right
               :description (tr [:dispatching/previous-date])
               :data-cy     "tomorrow"
               :fill        "var(--text-dark)"})]]])


(defn text-for-picked-date
  ([tr]
   (text-for-picked-date tr false))
  ([tr show-text-for-today?]
   (let [date-choice        (date-util/start-of-day (<sub [::inspection-sub/my-today-date]))
         current-date       (date-util/today-start-of-day)
         diff-between-dates (date-util/number-of-days-between-two-dates current-date date-choice 0 false)]
     (cond
       (> diff-between-dates 2)
       (str (futil/tr-month tr (.getMonth date-choice))
            " "
            (.getDate date-choice))

       (= diff-between-dates 2)
       (futil/tr-weekday tr (.getDay date-choice))

       (= diff-between-dates 1)
       (str/lower-case (tr [:date.tomorrow]))

       (and show-text-for-today?
            (= diff-between-dates 0))
       (str/lower-case (tr [:date.today]))

       (= diff-between-dates -1)
       (str/lower-case (tr [:date.yesterday]))

       (= diff-between-dates -2)
       (futil/tr-weekday tr (.getDay date-choice))

       (< diff-between-dates -2)
       (str (futil/tr-month tr (.getMonth date-choice))
            " "
            (.getDate date-choice))

       :else
       nil))))


(defn my-inspections-view [match]
  (let [tr       (<sub [::inspection-sub/inspections-tr])
        route    (<sub [::route])
        props    (util/mmap tr)
        bookings (<sub [::bookings])]
    [:div.cloudpermit-page
     [reassign-modal]
     [:div.mb-6
      [nav/breadcrumb (util/mmap tr match)]]
     [:div.flex.flex-col.lg:flex-row.justify-between
      [:div.flex.flex-col.md:flex-row.items-start.md:items-center
       [nav/back-to-dashboard-button tr]]
      [calendar-component tr]]
     (if (<sub [::inspection-sub/bookings-and-external-events-fetched?])
       [:<>
        [:div.flex.flex-wrap.justify-between.mt-6
         [:div.mt-1.mb-0
          [:h1 (str (tr [:inspection/my-today])
                    (when-let [date-text (text-for-picked-date tr false)]
                      (str " - " (str/capitalize date-text))))]]
         (when-not (empty? route)
           [:div
            (cc/button
              {:href             (str "https://www.google.com/maps/dir/" route)
               :kind             :tertiary
               :icon             i/map
               :class-name       "mr-2"
               :icon-description (tr [:inspection/navigation])}
              (tr [:inspection/navigation]))
            (cc/button
              {:href             "#"
               :kind             :tertiary
               :icon             i/redo
               :icon-description (tr [:inspection/reassign-all])
               :on-click         #(>evt [::inspection-reassign/start-reassign bookings])}
              (tr [:inspection/reassign-all]))])]
        (when (<sub [::no-content?])
          [:h3.mt-4 (str (tr [:inspection/no-inspections-for]) (text-for-picked-date tr true))])
        [inspections-quick-pass/quick-pass-modal props]
        [missed-list props]
        [bookings-list props]
        [ongoing-inspections-list props]
        [done-inspections-list props]]
       [cc/loading-spinner])]))


(def my-inspections
  {:name        :view/my-inspections
   :view        my-inspections-view
   :public?     false
   :controllers [{:start (fn [_]
                           (>evt [::inspection-sub/select-my-today-date (date-util/today-start-of-day)]))}]})
